export default "/images/555f7b2e9cbda0fa3582733c050ccced.avif";